module.exports = __webpack_public_path__ + "static/media/aquarium.84840375.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/icons/aquarium.svg
// module id = 261
// module chunks = 0